<template>
  <v-dialog v-model="internalDialog" fullscreen persistent>
    <v-card class="map-picker-card">
      <v-toolbar dark color="primary">
        <v-btn icon @click="closeDialog">
          <v-icon large>close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>Pick Location on Map</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="map-picker-content">
        <div id="gpsMap" class="map-fullscreen"></div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" :large="true" @click="closeDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" :large="true" @click="confirmMapLocation">Use Selected Location</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mapboxgl from 'mapbox-gl';
import locationApi from '../../api/locationApi'

export default {
  name: 'MapPickerDialog',
  props: {},
  data() {
    return {
      internalDialog: false,
      map: null,
      mapMarker: null,
      selectedLatLng: null,
      latitude: null,
      longitude: null,
      locationID: null
    };
  },

  methods: {
    showDialog(params = {}) {
      this.latitude = params.latitude || null;
      this.longitude = params.longitude || null;
      this.locationID = params.locationID || null;
      this.internalDialog = true;
      this.$nextTick(() => {
        this.initMap();
      });
    },
    closeDialog() {
      this.internalDialog = false;
      this.selectedLatLng = null;
      if (this.map) {
        this.map.remove();
        this.map = null;
        this.mapMarker = null;
      }
    },
    async initMap() {
      mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
      let center = null;
      // If locationID is provided, fetch locationGeoData first
      let geoData = null;
      if (this.locationID) {
        try {
          geoData = await locationApi.getLocationGeoJSONData(this.locationID);
        } catch (e) {
          geoData = null;
        }
      }
      // If latitude/longitude are set and valid, use them for center
      if (this.latitude != null && this.longitude != null && !isNaN(this.latitude) && !isNaN(this.longitude)) {
        center = [this.longitude, this.latitude];
      } else if (geoData && geoData.features && geoData.features[0]) {
        const feature = geoData.features[0];
        if (feature.geometry && feature.geometry.coordinates) {
          center = feature.geometry.coordinates[0][0];
        } else if (feature.properties && feature.properties.PlantCentre) {
          center = [feature.properties.PlantCentre.Long, feature.properties.PlantCentre.Lat];
        }
      }
      if (!center || !center[0] || !center[1]) {
        // set to uluru if no valid lat/lng
        const uluru = { lat: -25.344, lng: 131.031 };
        center = [uluru.lng, uluru.lat];
      }
      this.map = new mapboxgl.Map({
        container: 'gpsMap',
        style: 'mapbox://styles/mapbox/satellite-v9',
        minzoom: 1.3,
        center: center,
        zoom: 14
      });

      // Add geoJSON polygon layer if geoData exists
      if (geoData && geoData.features && geoData.features.length > 0) {
        this.map.on('load', () => {
          // Add the geojson source
          this.map.addSource('location-geojson', {
            type: 'geojson',
            data: geoData
          });
          // Add a fill layer for the polygon
          this.map.addLayer({
            id: 'location-fill',
            type: 'fill',
            source: 'location-geojson',
            paint: {
              'fill-color': '#0080ff',
              'fill-opacity': 0.3
            }
          });
          // Add an outline layer for the polygon
          this.map.addLayer({
            id: 'location-outline',
            type: 'line',
            source: 'location-geojson',
            paint: {
              'line-color': '#0080ff',
              'line-width': 2
            }
          });
        });
      }

      // If latitude/longitude are set, show marker
      if (this.latitude && this.longitude) {
        this.mapMarker = new mapboxgl.Marker({ color: 'red' })
          .setLngLat([this.longitude, this.latitude])
          .addTo(this.map);
      } else if (center) {
        // Show marker at center if no lat/lng
        this.mapMarker = new mapboxgl.Marker({ color: 'red' })
          .setLngLat(center)
          .addTo(this.map);
      }
      this.map.on('click', (e) => {
        const { lng, lat } = e.lngLat;
        this.selectedLatLng = { lat, lng };
        if (this.mapMarker) {
          this.mapMarker.setLngLat([lng, lat]);
        } else {
          this.mapMarker = new mapboxgl.Marker({ color: 'red' })
            .setLngLat([lng, lat])
            .addTo(this.map);
        }
      });
    },
    confirmMapLocation() {
      if (this.selectedLatLng) {
        this.$emit('pick', {
          latitude: this.selectedLatLng.lat,
          longitude: this.selectedLatLng.lng
        });
        this.closeDialog();
      }
    }
  }
}
</script>

<style>
@import 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';

.map-picker-card {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.map-picker-content {
  flex: 1 1 auto;
  display: flex;
  min-height: 0;
}
.map-fullscreen {
  flex: 1 1 auto;
  width: 100%;
  height: 89%;
  min-height: 400px;
}
</style>
